export default "__VITE_ASSET__DAI6qpAI__"